import React from 'react';
import { Footer, Whatain, Header, Blog } from './containers';
import { Brand, Navbar } from './components';

import './App.css';

const App = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    <Brand />
    <Whatain />
    <Blog />
    <Footer />
  </div>
);

export default App;
